module.exports = __webpack_public_path__ + "img/banner.7e2ba89a.png";